export enum UIReplacerName {
  ConversationLink = 'conversationLink',
  ImagePreview = 'imagePreview',
  Mention = 'mention',
}

export type UIReplacerHandlers = Record<
  string,
  (element: HTMLElement, event: Parameters<React.MouseEventHandler<HTMLElement>>[0]) => void
>;

export interface UIReplacer {
  name: UIReplacerName;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  replace?: (input: string, metaData?: Record<string, any>) => string;
  handlers?: UIReplacerHandlers;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadMetaData?: (input: string) => Promise<Record<string, any>>;
  parentStyles?: Record<string, unknown>;
}
